export const customStyles = (selectedValues: any[], visibleValue: any) => ({
    control: (provided: any, state: any) => ({
        ...provided,
        width: "15rem",
        height: '30px',
        minHeight: '30px',
        margin: '0px 150px 0px 0px ',
        fontSize: '13px',
        marginRight: "1rem",
        backgroundColor: '#fff',
        alignItems: 'center',
        borderColor: state.isFocused ? '#80bdff' : '#ced4da',
        boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0, 123, 255, 0.25)' : 'none',
        '&:hover': { borderColor: '#515151ff' },
    }),
    menu: (base: any) => ({
        ...base,
        zIndex: 9999,
        marginTop: '0.25rem',
        border: '1px solid rgba(0, 0, 0, 0.1)',
    }),
    option: (provided: any, state: any) => ({
        ...provided,
        padding: '8px 12px',
        fontSize: '14px',
        color: '#1a1a1a',
        borderRadius: "10px",
        backgroundColor: state.isSelected
            ? '#ADADB3'
            : state.isFocused
                ? '#f8f9fa'
                : '#fff',
        '&:active': { backgroundColor: '#dadada' },
    }),
    multiValue: (base: any, state: any) =>
        selectedValues.length > 1 && state.data.label !== visibleValue?.label
            ? { ...base, display: 'none' }
            : { ...base, backgroundColor: 'rgba(0, 0, 0, 0.06)', maxHeight: '24px', width: "9rem" },
    multiValueLabel: (base: any, state: any) =>
        selectedValues.length > 1 && state.data.label !== visibleValue?.label
            ? { ...base, display: 'none' }
            : {
                ...base,
                color: 'black',
                fontWeight: '500',
                padding: '2px 6px',
                fontSize: '12px',
            },
    multiValueRemove: (base: any, state: any) =>
        selectedValues.length > 1 && state.data.label !== visibleValue?.label
            ? { ...base, display: 'none' }
            : {
                ...base,
                color: 'black',
                ':hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.1)',
                    color: 'black',
                },
            },
    valueContainer: (base: any) => ({
        ...base,
        padding: '0 8px',
        height: '30px',
        display: 'flex',
        alignItems: 'center',
    }),
    indicatorsContainer: (base: any) => ({
        ...base,
        height: '30px',
        display: 'flex',
        alignItems: 'center',
        paddingRight: '4px',
    }),
    dropdownIndicator: (base: any) => ({
        ...base,
        padding: '4px',
        color: '#6c757d',
        height: '30px',
        display: 'flex',
        alignItems: 'center',
        ':hover': { color: '#495057' },
    }),
    clearIndicator: (base: any) => ({
        ...base,
        padding: '4px',
        color: '#6c757d',
        height: '30px',
        display: 'flex',
        alignItems: 'center',
        ':hover': { color: '#495057' },
    }),
});

export const customStyle = (selectedValues: any[]) => ({
    control: (provided: any, state: any) => ({
        ...provided,
        width: "15rem",
        minHeight: 30,
        height: 30,
        fontSize: "11px",
        backgroundColor: "#fff",
        alignItems: "center",
        boxShadow: "none",
    }),

    multiValue: (base: any, state: any) => {
        const index = selectedValues.findIndex(
            (v: any) => v.value === state.data.value
        );
        return index >= 2
            ? { ...base, display: "none" } // hide beyond 2
            : { ...base, backgroundColor: "rgba(0, 0, 0, 0.06)" };
    },

    multiValueLabel: (base: any, state: any) => {
        const index = selectedValues.findIndex(
            (v: any) => v.value === state.data.value
        );
        return index >= 2
            ? { ...base, display: "none" }
            : { ...base, fontSize: "12px", fontWeight: 500 };
    },

    multiValueRemove: (base: any, state: any) => {
        const index = selectedValues.findIndex(
            (v: any) => v.value === state.data.value
        );
        return index >= 2
            ? { ...base, display: "none" }
            : {
                ...base,
                color: "black",
                ":hover": {
                    backgroundColor: "rgba(0,0,0,0.1)",
                },
            };
    },

    valueContainer: (base: any) => ({
        ...base,
        padding: "0 8px",
        height: "30px",
        display: "flex",
        alignItems: "center",
    }),
});